/**
 * Global /risks page. EvaluationPickerSheet → on pick → RiskAssessmentWorkspace
 * (the G1+G2+G3 component) inside the shared module-page chrome. URL preserves
 * the picked evaluation via `?eval=<id>` so reload + share-link both work.
 *
 * Linear: MYD-215 (G4).
 *
 * Note on the "Sidebar Risks entry highlights" acceptance criterion: per the
 * user-locked sidebar IA (memory: feedback_sidebar_ia.md; canonical
 * implementation MYD-235), Risks is NOT a sidebar entry. The route `/risks`
 * remains valid and deep-linkable, but no sidebar item highlights for it.
 * The acceptance bullet is superseded by the IA lock — confirmed in the
 * Linear comment thread on this issue (Bucket-1 IA-lock comment, 2026-04-30).
 */

import EvaluationModulePage from './_EvaluationModulePage'
import RiskAssessmentWorkspace from '../components/risks/RiskAssessmentWorkspace'

const RisksPage = () => (
	<EvaluationModulePage
		moduleName="Risks"
		moduleDescription="Pick an evaluation to manage its risk register and impact-likelihood matrix."
		workspacePhase="MYD-214 (G3)"
		workspaceHint="Risk register, profile summary, and 5×5 likelihood × impact heatmap."
		renderWorkspace={(evalId) => <RiskAssessmentWorkspace evalId={evalId} />}
	/>
)

export default RisksPage
